export default __webpack_public_path__ + "static/media/campton_medium.1e87a6be.ttf";